export var MetapageEvents;
(function (MetapageEvents) {
    MetapageEvents["Inputs"] = "inputs";
    MetapageEvents["Outputs"] = "outputs";
    MetapageEvents["State"] = "state";
    MetapageEvents["Definition"] = "definition";
    MetapageEvents["DefinitionUpdateRequest"] = "definitionupdaterequest";
    MetapageEvents["Error"] = "error";
    MetapageEvents["UrlHashUpdate"] = "urlhashupdate";
    MetapageEvents["Message"] = "Message";
})(MetapageEvents || (MetapageEvents = {}));
//# sourceMappingURL=events.js.map